module.exports = __webpack_public_path__ + "static/img/29东万华.37302d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/29东万华.jpg
// module id = sPK8
// module chunks = 1